import NotAvailable from '../../components/fallback/NotAvailable'

const Messages: React.FC = () => {
  return <NotAvailable title={'Messages'} />
}

export default Messages
